import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaPhone,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
  FaInfoCircle,
  // FaList,
  // FaCheck,
  // FaTimes,
  // FaCamera,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { IoPeopleSharp } from "react-icons/io5";
// import { TbMoneybagHeart } from "react-icons/tb";
// import { GoSponsorTiers } from "react-icons/go";
import "../styles/GuestRegistration.css";
import CustomFormGroup from '../components/CustomFormGroup';
import CommonButton from '../components/CommonButton';
import { useLoading } from "../components/LoadingContext";
import MessageModal from '../components/MessageModal';
import { fetchEventDetail } from "../services/api/eventService";
import { registerGuests } from "../services/api/guestService";

const GuestRegistrationPage = () => {
  const formRef = useRef(null);
  const guestsRef = useRef([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const eventId = id;
  // const [rundown, setRundown] = useState([]);
  const [eventDetail, setEventDetail] = useState(null);
  const createGuest = () => ({
    full_name: '',
    phone: '',
    isDonate: false,
    packageId: '',
    proofOfDonationFile: null,
    proofOfDonationUrl: '',
    proofOfDonationPreview: null,
    isSponsor: false,
    sponsorPackageId: '',
    sponsorProofFile: null,
    sponsorProofPreview: null
  });
  const [guests, setGuests] = useState([createGuest()]);
  const [errors, setErrors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [modalMessage, setModalMessage] = useState([]);
  const { showLoading, hideLoading } = useLoading();
  const [isEventExpired, setIsEventExpired] = useState(false);
  const statusConfig = {
    berhasil: { text: 'Berhasil', color: 'green' },
    already_registered: { text: 'Sudah terdaftar sebelumnya', color: 'orange' },
    event_not_found: { text: 'Event tidak ditemukan', color: '#b00020' },
    package_unavailable: { text: 'Paket dana habis/tidak valid', color: '#b00020' },
    event_expired: { text: 'Event sudah berakhir', color: '#b00020' },
    gagal: { text: 'Gagal', color: 'red' }
  };
  // const [donatePackages, setDonatePackages] = useState([]);
  // const [sponsorPackages, setSponsorPackages] = useState([]);

  useEffect(() => {
    guestsRef.current = guests;
  }, [guests]);

  useEffect(() => {
    const loadData = async () => {
    const [dataEvent] = await Promise.all([
      fetchEventDetail(eventId),
      // fetchEventPackages(eventId)
    ]);

      if (!dataEvent) {
        navigate("/not-found");
        return;
      }

      setEventDetail(dataEvent);
      // setDonatePackages(dataPackages.filter(pkg => pkg.is_sponsor === false));
      // setSponsorPackages(dataPackages.filter(pkg => pkg.is_sponsor === true));

      const today = new Date();
      const eventDate = new Date(dataEvent.date);

      // buang jam biar pure tanggal
      today.setHours(0,0,0,0);

      if (eventDate < today) {
        setIsEventExpired(true);
      }
    };

    loadData();
  }, [eventId, navigate]);

  useEffect(() => {
    return () => {
      guestsRef.current.forEach(g => {
        if (g.proofOfDonationPreview) {
          URL.revokeObjectURL(g.proofOfDonationPreview);
        }
      });
    };
  }, []);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    if (name === 'phone' && !/^[+\-0-9]*$/.test(value)) return;
    const updatedGuests = [...guests];
    updatedGuests[index][name] = value;
    setGuests(updatedGuests);
  };

  const addGuestField = () => {
    setGuests([...guests, createGuest()]);
  };

  const removeGuestField = (index) => {
    if (guests.length === 1) return;

    const updatedGuests = [...guests];

    if (updatedGuests[index]?.proofOfDonationPreview) {
      URL.revokeObjectURL(
        updatedGuests[index].proofOfDonationPreview
      );
    }
    if (updatedGuests[index]?.sponsorProofPreview) {
      URL.revokeObjectURL(
        updatedGuests[index].sponsorProofPreview
      );
    }

    updatedGuests.splice(index, 1);
    setGuests(updatedGuests);

    const updatedErrors = [...errors];
    updatedErrors.splice(index, 1);
    setErrors(updatedErrors);
  };

  // const handleDonateChange = (index, e) => {
  //   const donate = e.target.value === "Yes";

  //   const updatedGuests = [...guests];

  //   updatedGuests[index].isDonate = donate;

  //   if (!donate) {
  //     if (updatedGuests[index].proofOfDonationPreview) {
  //       URL.revokeObjectURL(
  //         updatedGuests[index].proofOfDonationPreview
  //       );
  //     }

  //     updatedGuests[index].packageId = "";
  //     updatedGuests[index].proofOfDonationFile = null;
  //     updatedGuests[index].proofOfDonationUrl = "";
  //     updatedGuests[index].proofOfDonationPreview = null;

  //     const updatedErrors = [...errors];

  //     updatedErrors[index] = {
  //       ...(updatedErrors[index] || {}),
  //       packageId: "",
  //       proofOfDonationFile: ""
  //     };

  //     setErrors(updatedErrors);
  //   }

  //   setGuests(updatedGuests);
  // };

  // const handleSponsorChange = (index, e) => {
  //   const sponsor = e.target.value === "Yes";
  //   const updatedGuests = [...guests];

  //   updatedGuests[index].isSponsor = sponsor;

  //   if (!sponsor) {
  //     updatedGuests[index].sponsorPackageId = "";
  //     updatedGuests[index].sponsorProofFile = null;
  //     updatedGuests[index].sponsorProofPreview = null;
  //     const updatedErrors = [...errors];

  //     updatedErrors[index] = {
  //       ...(updatedErrors[index] || {}),
  //       sponsorPackageId: "",
  //       sponsorProofFile: ""
  //     };

  //     setErrors(updatedErrors);
  //   }

  //   setGuests(updatedGuests);
  // };

  // const handlePackageChange = (index, e) => {
  //   const updatedGuests = [...guests];
  //   updatedGuests[index].packageId = e.target.value;
  //   setGuests(updatedGuests);

  //   const updatedErrors = [...errors];
  //   updatedErrors[index] = {
  //     ...(updatedErrors[index] || {}),
  //     packageId: ""
  //   };

  //   setErrors(updatedErrors);
  // };

  // const handleSponsorPackageChange = (index, e) => {
  //   const updatedGuests = [...guests];
  //   updatedGuests[index].sponsorPackageId = e.target.value;
  //   setGuests(updatedGuests);

  //   const updatedErrors = [...errors];
  //   updatedErrors[index] = {
  //     ...(updatedErrors[index] || {}),
  //     sponsorPackageId: ""
  //   };

  //   setErrors(updatedErrors);
  // };

  // const handleProofOfDonationChange = async (index, e) => {
  //   const file = e.target.files?.[0];
  //   const maxSize = 5 * 1024 * 1024; // 5 MB

  //   const updatedGuests = [...guests];

  //   if (!file) {
  //     updatedGuests[index].proofOfDonationFile = null;
  //     updatedGuests[index].proofOfDonationPreview = null;

  //     setGuests(updatedGuests);
  //     return;
  //   }

  //   if (file.size > maxSize) {
  //     const updatedErrors = [...errors];

  //     updatedErrors[index] = {
  //       ...(updatedErrors[index] || {}),
  //       proofOfDonationFile: "Ukuran file maksimal 5 MB"
  //     };

  //     setErrors(updatedErrors);
  //     return;
  //   }

  //   updatedGuests[index].proofOfDonationFile = file;

  //   if (updatedGuests[index].proofOfDonationPreview) {
  //     URL.revokeObjectURL(
  //       updatedGuests[index].proofOfDonationPreview
  //     );
  //   }
  //   updatedGuests[index].proofOfDonationPreview =
  //     URL.createObjectURL(file);

  //   setGuests(updatedGuests);

  //   const updatedErrors = [...errors];
  //       updatedErrors[index] = {
  //     ...(updatedErrors[index] || {}),
  //     proofOfDonationFile: ""
  //   };

  //   setErrors(updatedErrors);
  // };

  // const handleSponsorProofChange = async (index, e) => {
  //   const file = e.target.files?.[0];
  //   const maxSize = 5 * 1024 * 1024; // 5 MB

  //   const updatedGuests = [...guests];

  //   if (!file) {
  //     updatedGuests[index].sponsorProofFile = null;
  //     updatedGuests[index].sponsorProofPreview = null;

  //     setGuests(updatedGuests);
  //     return;
  //   }

  //   if (file.size > maxSize) {
  //     const updatedErrors = [...errors];

  //     updatedErrors[index] = {
  //       ...(updatedErrors[index] || {}),
  //       sponsorProofFile: "Ukuran file maksimal 5 MB"
  //     };

  //     setErrors(updatedErrors);
  //     return;
  //   }

  //   updatedGuests[index].sponsorProofFile = file;

  //   if (updatedGuests[index].sponsorProofPreview) {
  //     URL.revokeObjectURL(
  //       updatedGuests[index].sponsorProofPreview
  //     );
  //   }
  //   updatedGuests[index].sponsorProofPreview =
  //     URL.createObjectURL(file);

  //   setGuests(updatedGuests);

  //   const updatedErrors = [...errors];
  //       updatedErrors[index] = {
  //     ...(updatedErrors[index] || {}),
  //     sponsorProofFile: ""
  //   };

  //   setErrors(updatedErrors);
  // };

  const validate = () => {
    const newErrors = guests.map(g => {
      const err = {};

      if (!g.full_name)
        err.full_name = "Nama Lengkap wajib diisi";

      if (!g.phone)
        err.phone = "Nomor Telepon wajib diisi";

      if (g.phone && !/^[+\-0-9]*$/.test(g.phone))
        err.phone = "Nomor Telepon hanya boleh angka, +, atau -";

      // if (g.isDonate) {
      //   if (!g.packageId)
      //     err.packageId = "Pilih jenis dana";

      //   const selectedPackage = donatePackages.find(
      //     pkg => String(pkg.id) === String(g.packageId)
      //   );
      //   const remainingQuantity = selectedPackage?.curr_quantity ?? selectedPackage?.quantity;

      //   if (
      //     selectedPackage &&
      //     remainingQuantity !== null &&
      //     remainingQuantity !== undefined &&
      //     Number(remainingQuantity) <= 0
      //   )
      //     err.packageId = "Paket dana ini sudah habis";

      //   if (!g.proofOfDonationFile)
      //     err.proofOfDonationFile = "Upload bukti dana";
      // }

      // if (g.isSponsor) {
      //   if (!g.sponsorPackageId)
      //     err.sponsorPackageId = "Pilih jenis sponsor";

      //   const selectedSponsorPackage = sponsorPackages.find(
      //     pkg => String(pkg.id) === String(g.sponsorPackageId)
      //   );
      //   const remainingQuantity = selectedSponsorPackage?.curr_quantity ?? selectedSponsorPackage?.quantity;

      //   if (
      //     selectedSponsorPackage &&
      //     remainingQuantity !== null &&
      //     remainingQuantity !== undefined &&
      //     Number(remainingQuantity) <= 0
      //   )
      //     err.sponsorPackageId = "Paket sponsor ini sudah habis";

      //   if (!g.sponsorProofFile)
      //     err.sponsorProofFile = "Upload bukti sponsor";
      // }

      return err;
    });
    setErrors(newErrors);
    return newErrors.every(err => Object.keys(err).length === 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    showLoading();

    const formData = new FormData();
    formData.append("eventId", eventId);
    try {
      guests.forEach((guest, index) => {
        formData.append(
          `guests[${index}][full_name]`,
          guest.full_name
        );

        formData.append(
          `guests[${index}][phone]`,
          guest.phone
        );

        formData.append(
          `guests[${index}][isDonate]`,
          guest.isDonate ? "true" : "false"
        );
        formData.append(
          `guests[${index}][isSponsor]`,
          guest.isSponsor ? "true" : "false"
        );

        if (guest.isDonate) {
          formData.append(
            `guests[${index}][packageId]`,
            guest.packageId
          );

          formData.append(
            `guests[${index}][proofOfDonationFile]`,
            guest.proofOfDonationFile
          );
        }

        if (guest.isSponsor) {
          formData.append(
            `guests[${index}][sponsorPackageId]`,
            guest.sponsorPackageId
          );

          formData.append(
            `guests[${index}][sponsorProofFile]`,
            guest.sponsorProofFile
          );
        }
      });

      const results = await registerGuests(formData);
      const hasSuccess = results.some(r => r.status === 'berhasil');
      // const latestPackages = await fetchEventPackages(eventId);

      setModalMessage(results);
      // setDonatePackages(latestPackages.filter(pkg => pkg.is_sponsor === false));
      // setSponsorPackages(latestPackages.filter(pkg => pkg.is_sponsor === true));
      setSuccess(hasSuccess);
      setIsModalOpen(true);

      // ✅ Reset hanya kalau ada yang berhasil
      if (hasSuccess) {
        setGuests([createGuest()]);
        setErrors([]);
      }

    } catch (err) {
      console.error(err);
      setSuccess(false);
      setModalMessage([
        { name: 'Semua', status: 'gagal', reason: 'Server error' }
      ]);
      setIsModalOpen(true);
    } finally {
      hideLoading();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (success) navigate('/thank-you');
  };

  const formatTime = (time) => {
    if (!time) return "-";

    return `${time.substring(0, 5)} WIB`;
  };

  if (!eventDetail) return null;

  if (isEventExpired) {
    return (
      <div className="guest-registration-page">
        <div className="event-info">
          <h2>Maaf, Event Sudah Berakhir</h2>
          <img src={eventDetail?.flyer} alt={eventDetail?.name} className="event-image" />
          <p>Pendaftaran untuk event {eventDetail?.name} telah ditutup.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="guest-registration-page">
      <div className="event-info">
        <img src="/assets/logo.png" alt="Logo" className="event-logo" />
        <h2>Form Pendaftaran Tamu</h2>
        <h3>{eventDetail?.name}</h3>
        {/* <p>{eventDetail?.description}</p> */}
        <img src={eventDetail?.flyer} alt={eventDetail?.name} className="event-image" />
        <div className="event-summary">
          <div className="summary-item">
            <FaCalendarAlt className="summary-icon" />

            <div className="summary-content">
              <div className="summary-label">
                {new Date(eventDetail.date)
                  .toLocaleDateString("id-ID", {
                    weekday: "long"
                  })
                  .toUpperCase()}
              </div>

              <div className="summary-date">
                <span className="day">
                  {new Date(eventDetail.date).getDate()}
                </span>

                <div className="month-year">
                  <div className="month">
                      {new Date(eventDetail.date)
                          .toLocaleDateString("id-ID", {
                              month: "long"
                          })
                          .toUpperCase()}
                  </div>

                  <div className="year">
                      {new Date(eventDetail.date).getFullYear()}
                  </div>
              </div>
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="summary-item">
            <FaClock className="summary-icon" />

            <div className="summary-content">
              <div className="summary-title">
                REGISTRASI
              </div>

              <div className="summary-text">
                {formatTime(eventDetail.registration_start)}
              </div>

              <div className="summary-title mt">
                ACARA
              </div>

              <div className="summary-text">
                {formatTime(eventDetail.event_start)} - Selesai
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="summary-item">
            <FaMapMarkerAlt className="summary-icon" />

            <div className="summary-content">
              <div className="summary-title">
                {eventDetail.location}
              </div>

              <div className="summary-address">
                {eventDetail.address}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="registration-wrapper">
        <div className="guest-note">
          <strong><FaInfoCircle style={{marginRight:6}}/> Catatan:</strong>
          <ul>
            <li>Jika ingin bertanya lebih lanjut tentang dana, silakan menghubungi WhatsApp <b>Bendahara KSN +62 822-5802-7289</b></li>
            <li>Nomor telepon boleh digunakan untuk lebih dari satu tamu.</li>
            <li>Namun <b>nama tamu harus berbeda</b> untuk setiap pendaftaran.</li>
          </ul>
        </div>
        <form className="register-form" onSubmit={handleSubmit} ref={formRef}>
          {guests.map((g, idx) => {
            // const selectedPackage = donatePackages.find(
            //   p => String(p.id) === String(g.packageId)
            // );
            // const selectedSponsorPackage = sponsorPackages.find(
            //   p => String(p.id) === String(g.sponsorPackageId)
            // );
            return (
              <div className="guest-field" key={idx}>
                <div className="guest-label-wrapper">
                  <span className="guest-label">Tamu {idx + 1}</span>
                  {guests.length > 1 && (
                    <button
                      type="button"
                      className="remove-guest-btn"
                      onClick={() => removeGuestField(idx)}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="guest-input-wrapper">
                  <CustomFormGroup
                    type="text"
                    name="full_name"
                    value={g.full_name}
                    onChange={(e) => handleChange(idx, e)}
                    placeholder="Nama Lengkap"
                    icon={<FaUser />}
                    error={errors[idx]?.full_name}
                  />
                  <CustomFormGroup
                    type="text"
                    name="phone"
                    value={g.phone}
                    onChange={(e) => handleChange(idx, e)}
                    placeholder="Nomor Telepon (WhatsApp)"
                    icon={<FaPhone />}
                    error={errors[idx]?.phone}
                  />
                </div>
                {/*     
                <div className="donate-section sponsor-section">
                  <label className="donate-label">
                    <GoSponsorTiers size={22} /> Apakah ingin menjadi Sponsor?
                    <span className="donation-badge">Opsional</span>
                  </label>
                  <CustomFormGroup
                    type="radio"
                    name={`sponsor_${idx}`}
                    value={g.isSponsor ? "Yes" : "No"}
                    onChange={(e) => handleSponsorChange(idx, e)}
                    options={[
                      {
                        label: "Ya",
                        value: "Yes",
                        icon: <FaCheck />
                      },
                      {
                        label: "Tidak",
                        value: "No",
                        icon: <FaTimes />
                      }
                    ]}
                  />
                  {g.isSponsor && (
                    <div>
                      <CustomFormGroup
                        type="select"
                        name="sponsor_package"
                        value={g.sponsorPackageId}
                        onChange={(e) => handleSponsorPackageChange(idx, e)}
                        placeholder="Pilih Jenis Sponsor"
                        options={sponsorPackages.map(pkg => ({
                          value: pkg.id,
                          label: pkg.package_name
                        }))}
                        icon={<FaList />}
                        error={errors[idx]?.sponsorPackageId}
                      />
                      {selectedSponsorPackage && (
                        <div className="donate-note">
                          <div>
                            {selectedSponsorPackage.price && (
                              <div className="donate-price">
                                Rp {Number(selectedSponsorPackage.price).toLocaleString("id-ID")}
                              </div>
                            )}

                            {selectedSponsorPackage.robe_qty !== null && selectedSponsorPackage.robe_qty !== undefined && (
                              <div className="donate-robe">
                                Jumlah jubah: {Number(selectedSponsorPackage.robe_qty)}
                              </div>
                            )}

                            {selectedSponsorPackage.package_detail && (
                              <div>
                                <div className="donate-benefit">
                                  ✨ Benefit Sponsor
                                </div>
                                <div className="donate-detail">
                                  {selectedSponsorPackage.package_detail}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <CustomFormGroup
                        type="file"
                        name="sponsorProofFile"
                        onChange={(e) => handleSponsorProofChange(idx, e)}
                        label="Unggah Bukti Sponsor"
                        icon={<FaCamera />}
                        accept="image/*"
                        error={errors[idx]?.sponsorProofFile}
                        filePreview={g.sponsorProofPreview}
                      />
                      <div className="donate-file-note">
                        <span>
                          Partisipasi tersebut dapat disalurkan ke: <br/>
                          <b>Rekening BCA 028-616-6789 a.n. Yayasan Kammatthanasamutapaka Nikaya</b>
                        </span>
                        <hr/>
                        <small>📌 Ukuran file maksimal 5 MB. Format: JPG, PNG, PDF</small>
                        <small>💬 Hubungi panitia jika terdapat kendala dalam mengunggah bukti dana.</small>
                      </div>
                    </div>
                  )}
                </div>
            
                <div className="donate-section dana-section">
                  <label className="donate-label">
                    <TbMoneybagHeart size={22}/> Apakah ingin berdana?
                    <span className="donation-badge">Opsional</span>
                  </label>
                  <CustomFormGroup
                    type="radio"
                    name={`donate_${idx}`}
                    value={g.isDonate ? "Yes" : "No"}
                    onChange={(e) => handleDonateChange(idx, e)}
                    options={[
                      {
                        label: "Ya",
                        value: "Yes",
                        icon: <FaCheck />
                      },
                      {
                        label: "Tidak",
                        value: "No",
                        icon: <FaTimes />
                      }
                    ]}
                  />
                  {g.isDonate && (
                    <div>
                      <CustomFormGroup
                        type="select"
                        name="donate_package"
                        value={g.packageId}
                        onChange={(e) => handlePackageChange(idx, e)}
                        placeholder="Pilih Jenis Dana"
                        options={donatePackages.map(pkg => ({
                          value: pkg.id,
                          label: pkg.package_name
                        }))}
                        icon={<FaList />}
                        error={errors[idx]?.packageId}
                      />
                      {selectedPackage && (
                        <div className="donate-note">
                          <div>
                            {selectedPackage.price && (
                              <div className="donate-price">
                                Rp {Number(selectedPackage.price).toLocaleString("id-ID")}
                              </div>
                            )}

                            {selectedPackage.robe_qty !== null && selectedPackage.robe_qty !== undefined && (
                              <div className="donate-robe">
                                Jumlah jubah: {Number(selectedPackage.robe_qty)}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <CustomFormGroup
                        type="file"
                        name="proofOfDonationFile"
                        onChange={(e) => handleProofOfDonationChange(idx, e)}
                        label="Unggah Bukti Dana"
                        icon={<FaCamera />}
                        accept="image/*"
                        error={errors[idx]?.proofOfDonationFile}
                        filePreview={g.proofOfDonationPreview}
                      />
                      <div className="donate-file-note">
                        <span>
                          Partisipasi tersebut dapat disalurkan ke: <br/>
                          <b>Rekening BCA 028-616-6789 a.n. Yayasan Kammatthanasamutapaka Nikaya</b>
                        </span>
                        <hr/>
                        <small>📌 Ukuran file maksimal 5 MB. Format: JPG, PNG, PDF</small>
                        <small>💬 Hubungi panitia jika terdapat kendala dalam mengunggah bukti dana.</small>
                      </div>
                    </div>
                  )}
                </div> */}
              </div>
            )}
          )}
          <div className="add-guest-wrapper">
            <CommonButton type="button" onClick={addGuestField}>
              <IoPeopleSharp size={18} style={{ marginRight: 4 }} />
              Tambah Tamu
            </CommonButton>
          </div>
        </form>

        {isModalOpen && (
          <MessageModal
            onClose={handleCloseModal}
            title="Hasil Pendaftaran"
            message_content={
            <div>
              <table className="table-guest-registration">
                <thead>
                  <tr>
                    <th>Nama Tamu</th>
                    <th>No HP</th>
                    {/* <th>Cluster</th> */}
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {modalMessage.map((r, idx) => (
                    <tr key={idx}>
                      <td>{r.name}</td>
                      <td>{r.phone}</td>
                      {/* <td>{r.status === "berhasil" ? r.cluster_code ?? "-" : "-"}</td> */}
                      <td
                        style={{
                          padding: '4px 8px',
                          color: statusConfig[r.status]?.color || 'red'
                        }}
                      >
                        {statusConfig[r.status]?.text}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* 🔽 Tambahan Keterangan Error */}
              {modalMessage.some(r => r.status === 'gagal') && (
                <div
                  style={{
                    marginTop: '16px',
                    padding: '12px',
                    backgroundColor: '#fff3f3',
                    border: '1px solid #f5c2c2',
                    borderRadius: '8px',
                    color: '#b00020',
                    fontSize: '14px'
                  }}
                >
                </div>
              )}
              <p className="error-message">
                Jika terdapat tamu yang gagal terdaftar, dapat menghubungi panitia untuk informasi lebih lanjut. <br/><br/>
                Terima kasih atas partisipasi Anda
              </p>
            </div>
          }

            icon={success ? <FaCheckCircle /> : <FaTimesCircle />}
            button_name="Close"
            isSuccess={success}
          />
        )}
      </div>

      <CommonButton type="button" onClick={() => formRef.current?.requestSubmit()}>
        Submit
      </CommonButton>
    </div>
  );
};

export default GuestRegistrationPage;
